export default __webpack_public_path__ + "static/duration-breakdown-dark-mode-da491e9b47bb84a68bd188765ae7bacc.png";